import React from "react"

import { SimulationWrapperType } from "@/test-set/simulation-wrappers"
import { SelectDropdown } from "@coval/ui"

interface SimulationWrapperSelectorProps {
  value?: SimulationWrapperType | null
  onChange: (type: SimulationWrapperType | null) => void
  showApiOption: boolean
  showCustomOption: boolean
}

const NONE_VALUE = "__none__"

export const SimulationWrapperSelector: React.FC<
  SimulationWrapperSelectorProps
> = ({ value, onChange, showApiOption, showCustomOption }) => {
  const handleSelectionChange = (selectedKey: string) => {
    if (selectedKey === NONE_VALUE) {
      onChange(null)
    } else if (selectedKey) {
      onChange(selectedKey as SimulationWrapperType)
    }
  }

  const selectedKey = value ? value : NONE_VALUE
  const options = [
    { value: NONE_VALUE, label: "None" },
    ...(showCustomOption
      ? [{ value: SimulationWrapperType.CUSTOM, label: "Custom API" }]
      : []),
    ...(showApiOption
      ? [{ value: SimulationWrapperType.API_WRAPPER, label: "API" }]
      : []),
  ]

  return (
    <SelectDropdown
      placeholder="Wrapper"
      value={selectedKey}
      onValueChange={handleSelectionChange}
      className="w-32 text-xs"
      options={options}
      aria-label="Select simulation wrapper type"
    />
  )
}
